import { render } from "./ProjectProcureAttachmentModal.vue?vue&type=template&id=40ee4a51&scoped=true&ts=true"
import script from "./ProjectProcureAttachmentModal.ts?vue&type=script&lang=ts"
export * from "./ProjectProcureAttachmentModal.ts?vue&type=script&lang=ts"

import "./ProjectProcureAttachmentModal.scss?vue&type=style&index=0&id=40ee4a51&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ee4a51"]])

export default __exports__